import { MatchingRuleService } from "../services/matchingRule.service";
import * as MatchingTypes from "./matchingTypes";

export const ResetMatching = () => (dispatch) => {
  dispatch({
    type: MatchingTypes.RESET_MATCHING_RULES,
  });
};

export const getMessageTypes = (error) => async (dispatch) => {
  try {
    const res = await MatchingRuleService.getMessageTypes();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: MatchingTypes.GET_MESSAGETYPE,
        payload: res.data.returnObject,
      });
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};
export const addNewRule = (data, success, error) => async (dispatch) => {
  debugger;
  try {
    const res = await MatchingRuleService.addNewRule(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const updateRule = (data, success, error) => async (dispatch) => {
  try {
    const res = await MatchingRuleService.updateRule(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const getFields = (data, part) => async (dispatch) => {
  try {
    const res = await MatchingRuleService.getFields(data);

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: MatchingTypes.GET_FIELDS,
        payload: { data: res.data.returnObject, partNumber: part },
      });
    } else {
      console.log(res.data.message);
    }
  } catch (e) {
    console.log(e.message);
  }
};

export const DeleteRules = (data, error, success) => async (dispatch) => {
  try {
    const res = await MatchingRuleService.DeleteRule(data);

    if (res.data.responseCode === "SUCCESS") {
      success(res.data.message);
    } else {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};

export const getRules = (error) => async (dispatch) => {
  dispatch({ type: MatchingTypes.SET_PROCESSING_MATCHING_RULE });
  try {
    const res = await MatchingRuleService.getRules();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: MatchingTypes.GET_RULES,
        payload: res.data.returnObject,
      });
    } else {
      dispatch({ type: MatchingTypes.STOP_PROCESSING_MATCHING_RULE });

      error(res.data.message);
    }
  } catch (e) {
    dispatch({ type: MatchingTypes.STOP_PROCESSING_MATCHING_RULE });

    error("error");
  }
};

export const ElementsFields = (data, part) => (dispatch) => {
  dispatch({
    type: MatchingTypes.GET_ELEMENTS,
    payload: { data: data.messageElements, partNumber: part },
  });
};
